module.exports = __webpack_public_path__ + "img/1.b65fd9e8.jpg";